export const CONTACT = {
  email: "tusharmelmalgi@skaristechnologies.com",
  phone: "+91 94900 66099",
  phoneHref: "tel:+919490066099",
  address: ["509N, Road Number 92", "Film Nagar Site-2, Hyderabad", "Telangana 500033"],
  hours: "[Mon – Fri, 10:00 – 19:00 IST]",
  socials: [
    { label: "LinkedIn", href: "#" },
    { label: "Instagram", href: "#" },
    { label: "X / Twitter", href: "#" },
    { label: "GitHub", href: "#" },
  ],
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Contact", to: "/contact" },
];

export const PILLARS = [
  {
    id: "it",
    n: "01",
    title: "IT Services",
    short: "Custom software, web platforms and management portals — architected, built, deployed and supported end-to-end.",
    img: "/img/office.jpg",
    points: ["Web development & headless CMS", "Custom software & management portals", "Enterprise tooling & project tracking", "Post-launch support & maintenance"],
    long: "We take ownership of the full build — requirements, architecture, development, deployment and a structured maintenance period after go-live. One lean team, direct access, no agency overhead.",
  },
  {
    id: "digital",
    n: "02",
    title: "Digital Transformation",
    short: "Replace spreadsheets, manual status updates and disconnected tools with systems your teams actually use.",
    img: "/img/diamonds.jpg",
    points: ["Process mapping & workflow digitisation", "Cloud services & migration", "IT consulting & architecture decisions", "Field + central-desk operational tools"],
    long: "We help operations-heavy organisations move from paper, email threads and spreadsheets to purpose-built platforms — giving every team live visibility into assets, tasks and progress.",
  },
  {
    id: "ai",
    n: "03",
    title: "AI Transformation",
    short: "AI-enabled features and data analytics built into your applications — turning operational data into usable insight.",
    img: "/img/handshake.jpg",
    points: ["AI features inside existing products", "Computer vision & edge inference", "Data pipelines & analytics dashboards", "Automation of repetitive workflows"],
    long: "From object-detection models running on edge hardware to analytics layers on top of your operational data, we ship AI where it measurably changes how work gets done.",
  },
];

export const CAPABILITIES = [
  { key: "web", n: "01", title: "Web Development", body: "Production-ready websites designed around your brand and operations — from corporate sites to client-facing portals, including headless CMS so you control content without touching code.", img: "/img/monitor.jpg" },
  { key: "portals", n: "02", title: "Custom Software & Management Portals", body: "Purpose-built web applications for tracking, managing and reporting on assets and workflows — including deployment tracking across hundreds of sites and thousands of serialised items.", img: "/img/office.jpg", tile: "/img/cap-portals.jpg" },
  { key: "tooling", n: "03", title: "Enterprise Tooling & Project Tracking", body: "Internal tools that give teams visibility into live project status, task ownership and progress — reducing reliance on spreadsheets and manual updates.", img: "/img/cubes.jpg", tile: "/img/cap-tooling.jpg" },
  { key: "consulting", n: "04", title: "IT Consulting", body: "Advisory support on technology strategy, architecture decisions and infrastructure planning for complex builds or upgrades.", img: "/img/diamonds.jpg", tile: "/img/cap-consulting.jpg" },
  { key: "cloud", n: "05", title: "Cloud Services & Migration", body: "Planning and execution of cloud infrastructure setup and migrations — moving workloads reliably with minimal disruption.", img: "/img/glass.jpg", tile: "/img/cap-cloud.jpg" },
  { key: "ai", n: "06", title: "AI & Data Analytics", body: "AI-enabled features and analytics capabilities built into your applications, turning operational data into usable insight.", img: "/img/handshake.jpg", tile: "/img/cap-ai.jpg" },
];

export const CASES = [
  {
    key: "junction",
    name: "Junction",
    kicker: "Marketplace · Mobile · Trust & Safety",
    tagline: "A safe, student-only marketplace for campus trading.",
    img: "/img/students.jpg",
    problem: "Students traded used goods over WhatsApp and OLX — channels with scams, fake listings and unsafe meetups with strangers.",
    solution: "Verified student-only access via college email or human-reviewed ID, in-app chat with offers, distance-ranked listings with map-based meetup suggestions, ratings, optional bidding and a moderation portal.",
    stats: [
      { v: "2,500+", l: "Verified students" },
      { v: "4.2★", l: "App Store & Play rating" },
      { v: "20%", l: "Sell-through rate" },
      { v: "5 mo", l: "Concept to live" },
    ],
    stack: ["Flutter", "Node.js", "Firebase"],
    meta: "Live on iOS & Android · Hyderabad, Bangalore, Manipal, Mangalore",
  },
  {
    key: "gamesense",
    name: "Gamesense",
    kicker: "Sports Tech · Edge AI · Computer Vision",
    tagline: "Instant replay for racket-sport courts — no internet, no app.",
    img: "/img/court.jpg",
    problem: "In recreational racket sports, line calls get settled by argument, great rallies are lost, and venues need a premium offering without another software bill.",
    solution: "A court-side tablet with twin 120 fps global-shutter cameras and an edge-first venue computer for rolling buffer, slow-motion replay and clip encoding — YOLO-based ball detection, privacy-by-design deletion and a revenue-share model that is free for venues upfront.",
    stats: [
      { v: "<5s", l: "Replay start (95% target)" },
      { v: "120fps", l: "Global-shutter capture" },
      { v: "99%", l: "Uptime target" },
      { v: "10", l: "Venues in 6 months (goal)" },
    ],
    stack: ["React", "Node.js", "Python", "YOLO"],
    meta: "Pilot planned · Hyderabad",
  },
];

export const PROCESS = [
  { n: "01", title: "Discover & Scope", body: "Requirements, constraints and success metrics — captured directly with your stakeholders, no account-manager relay." },
  { n: "02", title: "Architect", body: "System design, stack decisions and a fixed, phased plan so you know exactly what lands at each milestone." },
  { n: "03", title: "Build & Deploy", body: "Iterative development with live previews, then a reliable production rollout to your cloud or ours." },
  { n: "04", title: "Support & Evolve", body: "A structured maintenance period after go-live, then continued iteration as your operations grow." },
];

export const VALUES = ["Trust", "Speed", "Safety", "Professional", "Tracking", "Reliable", "Customer First", "Accountability"];

export const MARQUEE = ["IT Services", "Digital Transformation", "AI Transformation", "Built for your business", "Engineered to perform"];

export const STACK = ["React", "Flutter", "Node.js", "Python", "Firebase", "Headless CMS", "Cloud Infrastructure", "Computer Vision", "Data Analytics", "REST & Realtime APIs"];

export const PHASES = [
  { n: "P0", title: "Discovery", body: "Workshops, requirement capture, scope document.", note: "[Fixed fee — on request]" },
  { n: "P1", title: "Architecture", body: "System design, UX flows, phased delivery plan.", note: "[Fixed fee — on request]" },
  { n: "P2", title: "Build", body: "Sprints with demos at every milestone.", note: "[Fixed fee per milestone]" },
  { n: "P3", title: "Deploy", body: "Production rollout, data migration, training.", note: "[Fixed fee — on request]" },
  { n: "P4", title: "Maintain", body: "Structured post-launch support period.", note: "[Included / retainer]" },
];

export const FAQ = [
  { q: "How do you price projects?", a: "On a fixed, phased basis. Each phase has a clear scope and price agreed upfront, so you always know what to expect at every milestone." },
  { q: "Do you work with enterprises or startups?", a: "Both. Our core is enterprise and infrastructure-sector clients, and we also partner with founders building new products like Junction and Gamesense." },
  { q: "What happens after launch?", a: "Every engagement includes a structured maintenance period after go-live. After that, we can continue on a support retainer or iterate on new phases." },
  { q: "Can you work with our existing systems?", a: "Yes. We regularly integrate with existing databases, ERPs and cloud setups, and can plan migrations with minimal disruption." },
];

export const TEAM = [
  { name: "Sai Jitvan Alluri", role: "Founder / Product Lead" },
  { name: "Tushar Melmalgi", role: "Founder / Engineering Lead" },
  { name: "Mahitha Kallam", role: "Design Lead" },
  { name: "Sharanagouda", role: "Director" },
];

export const SERVICE_OPTIONS = ["IT Services", "Digital Transformation", "AI Transformation", "Web Development", "Cloud & Migration", "Not sure yet"];
export const BUDGETS = ["[< ₹5L]", "[₹5L – ₹15L]", "[₹15L – ₹40L]", "[₹40L +]"];
